module.exports = __webpack_public_path__ + "static/img/icon_momo.993b9349.png";